import config from './config.json';

export default function reverse(coordinates, reverse = true) {
    if (!reverse) {
        return coordinates;
    }

    return { x: config.canvas.width - coordinates.x, y: coordinates.y };
}
